<div class="row page-wrapper">
    <div></div>
    <div class="col-lg-4 col-xl-3 col-md-12" [ngSwitch]="TreatementSelection">



        <div class="">

            <div class="card medicationtext">
                <div class="card text-dark bg-light">
                    <div class="card-body ">
                        <div class="card-text text-left">
                            <div class="row left-form PatientDosepanenl">
                                <div i18n="@@preInfusionHeading" class="col-md-12 col-sm-12 Dosetitle">Pre infusion heading en</div>
                                <div class="col-md-12 col-sm-12 Dose-vails">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12" *ngIf="cancelPreText; else cancelBlock">
                                            <textarea  #pretext (keyup)="saveAndCancel1= false;" type="button" class="form-control inputclickAccept" spellcheck="false"
                                             [disabled]="!_dvmp.enableInputTextboxes" id="exampleFormControlTextarea1" postmedication rows="8">{{_premedicationtext}}</textarea>
                                        </div>
                                        <ng-template #cancelBlock>
                                            <div class="col-md-12 col-sm-12">
                                                <textarea  type="button" class="form-control inputclickAccept" spellcheck="false" id="exampleFormControlTextarea1" #pretext
                                                 postmedication rows="8">{{_premedicationtext}}</textarea> </div>
                                        </ng-template>
                                        <div *ngIf="_dvmp.enableInputTextboxes" class="darza-btn-container">
                                            <button i18n="@@saveBtn" (click)="dialogModalPrePost()" data-toggle="modal" data-target="#myModal" class="save-btn" [disabled]="saveAndCancel1">Save btn en</button>
                                            <button i18n="@@cancelBtn" mat-button color="primary" (click)="cancelPreMedication()" [disabled]="saveAndCancel1">Cancel btn en</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="row left-form PatientDosepanenl">
                                <div i18n="@@postInfusionHeading" class="col-md-12 col-sm-12 Dosetitle">Post infusion heading en</div>
                                <div class="col-md-12 col-sm-12 Dose-vails">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12" *ngIf="cancelPostText; else postBlock">
                                            <textarea   type="button" class="form-control inputclickAccept" id="exampleFormControlTextarea2" #posttext spellcheck="false"
                                            [disabled]="!_dvmp.enableInputTextboxes" rows="8" (keyup)="saveAndCancel2= false">{{_postmedicationtext}}</textarea>
                                        </div>
                                        <ng-template #postBlock>
                                            <div class="col-md-12 col-sm-12">
                                                <textarea type="button" class="form-control inputclickAccept" id="exampleFormControlTextarea2" #posttext spellcheck="false"
                                                rows="8">{{_postmedicationtext}}</textarea>
                                            </div>
                                        </ng-template>
                                        <div *ngIf="_dvmp.enableInputTextboxes" class="darza-btn-container">
                                            <button i18n="@@saveBtn" (click)="dialogModalPrePosts()" data-toggle="modal" data-target="#myModal" class="save-btn" [disabled]="saveAndCancel2">Save btn en</button>
                                            <button i18n="@@cancelBtn" mat-button color="primary" (click)="cancelPostMedication()" [disabled]="saveAndCancel2">Cancel btn en</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row left-form PatientDosepanenl">
                                <div i18n="@@profilaxisheading" class="col-md-12 col-sm-12 Dosetitle">Profilaxisheading en</div>
                                <div class="col-md-12 col-sm-12 Dose-vails">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12" *ngIf="cancelProfilText; else prePostBlock">
                                            <textarea type="button" (keyup)="saveAndCancel3= false" #profil class="form-control inputclickAccept" id="exampleFormControlTextarea3"
                                            [disabled]="!_dvmp.enableInputTextboxes" spellcheck="false" rows="8">{{_dosetext}}</textarea>
                                        </div>
                                        <ng-template #prePostBlock>
                                            <div class="col-md-12 col-sm-12">
                                                <textarea type="button" #profil class="form-control inputclickAccept" id="exampleFormControlTextarea3" spellcheck="false"
                                                rows="8">{{_dosetext}}</textarea>
                                            </div>
                                        </ng-template>
                                        <div *ngIf="_dvmp.enableInputTextboxes" class="darza-btn-container">
                                            <button i18n="@@saveBtn" (click)="dialogModalPrePostMedication()" data-toggle="modal" data-target="#myModal" class="save-btn" [disabled]="saveAndCancel3">Save btn en</button>
                                            <button i18n="@@cancelBtn" mat-button color="primary" (click)="cancelPrePostMedication()" [disabled]="saveAndCancel3">Cancel btn en</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="prepostMedication">
                                <!-- Modal -->
                                <div data-backdrop="static" data-keyboard="false" class="modal fade textAreaDialog " id="myModal" role="dialog" tabindex="-1">
                                    <div class="modal-dialog">
                                        <!-- Modal content-->
                                        <div class="modal-content">
                                            <div class="modal-header">
                                            </div>
                                            <div class="modal-body">
                                                <h4 i18n="@@prePostMedEditAlertText">Pre post med edit alert text en</h4>
                                            </div>
                                            <div class="modal-footer">
                                                <button i18n="@@acceptBtn" type="button" class="btn btn-primary" data-dismiss="modal">Accept btn en</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div i18n="@@termsButton" class="terms-condition-btn" (click)="termsconditionclick()">Terms button en</div>
        <!-- Modal -->
        <div *ngIf="modalCollapse">
            <div data-backdrop="static" data-keyboard="false" class="modal fade textAreaDialog" id="inputPopUp" role="dialog" tabindex="1">
                <div class="modal-dialog">
                    <!--  Modal content -->
                    <div class="modal-content">
                        <div class="modal-header">
                        </div>
                        <div class="modal-body">
                            <h5>La dosis indicada no es la establecida por Ficha Técnica</h5>
                        </div>
                        <div class="modal-footer">
                            <button (click)="inputclickAccept()" type="button" class="btn btn-primary" data-dismiss="modal">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-8 col-xl-9 col-md-12 darza-calender-view">
        <div class="calender-header new-pdf-header">
            <div class="header-wrap clearfix">
                <div class="header-wrapleft">
                    <h2 id="DVmpId" appSuperscript [innerHTML]="treatmentfullname"></h2>
                </div>
            </div>

            <div class="fechadate">
                <h3 i18n="@@treatStartDate" class="date-txt">T</h3>
                <span>{{printedstarted | date:'dd/MM/yyyy'}}</span>
            </div>
            <!-- <a routerLink="/" routerLinkActive="active" class="btn btn-primary btn-sm"></a> -->
            <div class="leyenda">
                <h3 i18n="@@legendsheading">Legendsheading en</h3>
                <div class='circle-list'>
                    <span *ngFor="let admin of adminstration " class="circle-icon">
                        <i [ngStyle]="{'color':_colors[admin.value].primary}" class="fas fa-circle"></i>
                        <span>
                            {{admin.disp_name | titlecase}}</span>
                    </span>
                    <span i18n="@@festival" class="holiday-notation">Festival en</span>
                </div>
            </div>

            <div class="treatments">
                <!-- <h3>Dosis por administración: </h3>

                <div class="leyenda-list">
                    <span *ngFor="let treatoptions of treatlabels " class="circle-icon">
                        <div *ngIf="_dose != _dose[treatoptions]">
                            <span *ngIf="_dose[treatoptions] != 0">{{treatoptions}}: {{ _dose}}{{_dose[treatoptions]}} mg</span>
                        </div>
                    </span>
                </div> -->

                <div class="button-alignmnet text-right">
                    <!-- <button (click)="specialPopulation()" class='btn btn-primary'>SPECIAL POPULATION</button> -->
                    <!--ADOJ-1-->
                    <button (click)="generatePDF()" class='btn btn-primary'>
                        <i [ngClass]="{'fas fa-spinner': is_pdfloadinng , ' far fa-file-pdf': !is_pdfloadinng } "></i>
                        <span i18n="@@gPDFbtn">Generate pdf en</span>
                    </button>
                    <button routerLink="/" class='btn btn-primary'>
                        <i class="fas fa-users"></i>
                        <span i18n="@@newPatientButton">New patient en</span></button>

                </div>
            </div>
        </div>
        <div class="calender-header cal-pdf-print printable-section">
            <div class="header-wrap clearfix">
                <div class="header-wrapleft">
                    <span class="triangle-down"></span>
                    <h2 id="DVdpId" appSuperscript [innerHTML]="treatmentfullname"></h2>
                </div>
            </div>

            <div class="fechadate">
                <h3 i18n="@@treatStartDate" class="date-txt">Treat start date en</h3>
                <span>{{printedstarted | date:'dd/MM/yyyy'}}</span>
            </div>
            <!-- <a routerLink="/" routerLinkActive="active" class="btn btn-primary btn-sm"></a> -->
            <div class="leyenda">
                <h3 i18n="@@legendsheading">Legendsheading en</h3>
                <div class='circle-list'>
                    <span *ngFor="let admin of adminstration " class="circle-icon">
                        <i [ngStyle]="{'color':_colors[admin.value].primary}" class="fas fa-circle-css"></i>
                        <span>
                            {{admin.value | titlecase}}</span>
                    </span>
                    <span i18n="@@festival" class="holiday-notation">Festival</span>
                </div>
            </div>

            <div class="treatments">
                <h3>Dosis por administración: </h3>

                <div class="leyenda-list">
                    <span *ngFor="let treatoptions of treatlabels " class="circle-icon">
                        <div *ngIf="_dose != _dose[treatoptions]">
                            <span *ngIf="_dose[treatoptions] != 0">{{treatoptions}}: {{ _dose}}{{_dose[treatoptions]}} mg</span>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div i18n="@@warningTextBelowCal" class="permanentwarningMsg" *ngIf="pdfDisclaimerText">Warning text below cal en</div>
        <!--Added display component here-->
        <!-- <div class="cals-parent">
      <div class="row cals" *ngIf="_events_availability">
         <label>{{_events.title }} </label> -->
        <!-- <div class="col-md-12 col-sm-12 cal-pdf-print printable-section" *ngFor="let vDate of viewDate;let i = index">

          <app-displaycalendar class="calendar-display" *ngIf="toggle" (onChange)="updatedevents($event)" [printMonth]="vDate" [index]="i"
            [calevents]="_events" [drugDosageValues]="toggleFilterEvents" (beforeViewRender)="beforeMonthViewRender($event)"></app-displaycalendar>

          <app-displaycalendar *ngIf="!toggle" (onChange)="updatedevents($event)" [printMonth]="vDate" [index]="i"
            [calevents]="_events" [drugDosageValues]="toggleFilterEvents" (beforeViewRender)="beforeMonthViewRender($event)"></app-displaycalendar>
        </div> -->
        <!-- <div class="row cals" *ngIf="_events_availability && !toggle ">
           
              <div class="col-md-12 col-sm-12 printable-section" *ngFor="let vDate of viewDate;let i = index">
                <app-displaycalendar (onChange)="updatedevents($event)" [printMonth]="vDate" [index]="i"  [calevents]="_events" (beforeViewRender)="beforeMonthViewRender($event)"></app-displaycalendar>
              </div>
              
            </div> -->
        <!--</div>
    
  </div> -->
        <ng-template #customCellTemplate let-day="day" let-locale="locale">
            <div class="cal-cell-top">
                <div class="date-container">
                    <span class="cal-day-badge" *ngIf="day.badgeTotal"><span i18n="@@cycleHeader">Cycle en</span> {{ day.badgeTotal }}</span>
                    <span class="cal-day-badge"  *ngIf="(day.date | date:'shortDate')===(daydisplay | date:'shortDate')">{{cycledate}}</span>
                    <span class="cal-day-number" month="">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
                </div>
                <small>
                    <div *ngFor="let event of day.events">
                        <div class="container holiday" *ngIf="event.type=='holiday' && day.inMonth">
                            <div class="row">
                                <div class="col-md-12 holidayevent">
                                    <span mwlCalendarTooltip={{event.fullname}} [tooltipAppendToBody]="true"  [tooltipEvent]="dayEvent" [tooltipTemplate]="cellTooltipTemplate"
                                     [tooltipPlacement]="'top'">{{ event.title | titlecase }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let event of day.events;let i=index">
                        <div class="container legends" *ngIf="event.title !== '' && event.type === 'legends' && day.inMonth">
                            <div class="row ">
                                <div class="col-md-12   eventwrapper">
                                    <div class="eventbullets">
                                        <div *ngIf="_dvmp.DragnDropWithPopup" (click)="editDrugEvent(event)"  [class.cal-draggable]="event.draggable" dragActiveClass="cal-drag-active"
                                            mwlDraggable [dropData]="{event: event, draggedFrom: day}" [dragAxis]="{x: event.draggable, y: event.draggable}">
                                            <i class="fas fa-circle-css eventday circle-icon" [ngStyle]="{'background-color': event.color}"></i>
                                            <span>{{ event.title | titlecase }}</span>
                                        </div>
                                        <div *ngIf="!_dvmp.DragnDropWithPopup" [class.cal-draggable]="event.draggable" dragActiveClass="cal-drag-active"
                                            [dropData]="{event: event, draggedFrom: day}" [dragAxis]="{x: event.draggable, y: event.draggable}">
                                            <i class="fas fa-circle-css eventday circle-icon" [ngStyle]="{'background-color': event.color}"></i>
                                            <span>{{ event.title | titlecase }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </small>
            </div>
        </ng-template>

        <div class="cals-parent">
            <div class="row cals">

                <div class="col-md-12 col-sm-12 cal-pdf-print printable-section" *ngFor="let vDate of viewDate;let i = index">
                    <div *ngIf="month_display">
                        <div class="col-md-12 col-sm-12">
                            <h3 class="month-title">{{ vDate | calendarDate:'monthViewTitle':locale | titlecase }}</h3>
                        </div>
                        <mwl-calendar-month-view [viewDate]="vDate" [events]="totalEvents" [locale]="locale" [refresh]="refresh" [weekStartsOn]="weekStartsOn"
                            [weekendDays]="weekendDays" [cellTemplate]="customCellTemplate" (beforeViewRender)="beforeMonthViewRender($event)"
                            (eventTimesChanged)="eventTimesChanged($event)">
                        </mwl-calendar-month-view>
                    </div>

                </div>
            </div>
            <!--ended display component-->

        </div>
        <!-- printable section start here-->
        <div class="pdfmodel" id="contentToConvert">
            <div class="col-md-12">
                <div class="row  printable-section observationandpostpremedictiontext">
                    <div class=" Observation ">
                        <div class="postmedicationtext">
                            <label i18n="@@observationHeader">Observation header en</label>
                            <div class="textarea-observation">
                                {{Observations}}
                            </div>
                        </div>
                    </div>
                    <div class="postpremedictiontext">
                        <div class="col-md-12 col-sm-12 postmedicationtext">
                            <label i18n="@@preInfusionHeading">Pre infusion heading en</label>
                            <p>{{_premedicationtext}}</p>
                        </div>
                        <div class="col-md-12 col-sm-12 postmedicationtext">
                            <label i18n="@@postInfusionHeading">Post infusion heading en</label>
                            <p>{{_postmedicationtext}}</p>
                        </div>
                        <div class="col-md-12 col-sm-12 postmedicationtext">
                            <label i18n="@@profilaxisheading">Profilaxisheading en</label>
                            <p>{{_dosetext}}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-12 col-sm-12  terms-conditions">
                        <div class="printable-section col-md-12 col-sm-12">
                            <!-- <markdown class="printable-section" [src]="'../../../assets/files/text.md'"></markdown> -->
                            <p i18n="@@warningTextBelowCal" class="nopadding" *ngIf="pdfDisclaimerText">Warning text pdf en</p>
                            <p i18n="@@termsSec1" class="nopadding">
                                Terms section en                            </p>
                            <div i18n="@@termsHeading" class="heading" style="text-decoration: underline">
                                Terms heading en
                            </div>
                            <ul>
                                <li i18n="@@termsSec2">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec3">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec4">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec5">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec6">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec7">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec8">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec9">
                                    Terms section en
                                </li>
                                <li i18n="@@termsSec10">
                                    Terms section en
                                </li>
                            </ul>
                            <!-- </div>
                        <div class="printable-section col-md-12 col-sm-12"> -->
                            <ul>
                                <li i18n="@@termsSec11" class="addunderline">
                                    Terms section en
                                </li>
                            </ul>
                            <p i18n="@@termsSec12" class="addItalic">Terms section en</p>
                            <p i18n="@@termsSec13">
                                Terms section en
                            </p>
                            <p i18n="@@termsSec14" class="beforeP" class="beforePdf">
                                &nbsp;&nbsp;&nbsp;&nbsp;Terms section en
                            </p>
                            <p i18n="@@termsSec15">
                                - &nbsp; Terms section en
                            </p>
                            <p i18n="@@termsSec16">
                                Terms section en                            </p>
                            <p i18n="@@termsSec17"> -&nbsp; Terms section en
                            </p>
                            <p i18n="@@termsSec18">
                                Terms section en
                            </p>
                            <p i18n="@@termsSec19" class="beforePdf">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Terms section en.</p>
                            <p i18n="@@termsSec20" class="beforePdf">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Terms section en
                                </p>
                            <p i18n="@@termsSec21" class="addItalic">
                                Terms section en
                            </p>
                            <p i18n="@@termsSec22">
                                Terms section en
                            </p>
                            <p i18n="@@termsSec23"> 
                                -&nbsp; Terms section en
                            </p>
                            <p i18n="@@termsSec24">
                                Terms section en                            </p>
                            <p i18n="@@termsSec25">
                                -&nbsp; Terms section en
                            </p>
                            <p i18n="@@termsSec26">
                                Terms section en
                            </p>
                            <p i18n="@@termsSec27">
                                Terms section en
                            </p>
                            <p i18n="@@termsSec28" class="addItalic">Terms section en
                            </p>
                            <p i18n="@@termsSec29">
                                Terms section en                            </p>

                            <ul>
                                <li i18n="@@termsSec30">
                                    Terms section en                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- printable section end here-->
            <!-- model for info -->
            <div class="clear-fix"></div>
        </div>
        <!-- info-model start here-->
        <div class="modal" id="info-model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            Según la fórmula de DuBois y DuBois, Arch Intern Med. 17.863. 1961: S= W0,425 x H0,725 x 71,48, o log S=0,425 log W + 0,725
                            log H + 1,8564; donde S = área de superficie corporal en cm2; W= al peso en kg; H= estatura en
                            cm.
                        </p>
                        <!-- <p>"According to the DuBois y DuBois formula, 
            Arch Intern Med. 17.863. 1961: S= W0,425 x H0,725 x 71,48, o log S=0,425 log W + 0,725 log H + 1,8564; 
            where S = body surface area in cm2; W= weight in Kg; H= height in cm.” </p> -->
                    </div>

                </div>
            </div>
        </div>
        <!-- info-model end here-->
        <!-- loadingPopup start here-->
        <div class="modal" id="loadingPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="loading window">
                            <div id="cover-spin"></div>
                            <h5 _ngcontent-c1="" class="title text-center">Descargando PDF</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- loadingPopup end here-->
        <!-- special population start here-->
        <div class="modal" id="specialPopulation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body ">
                        <button type="button" class="close" data-dismiss="modal" (click)="closespecialPopulation()">&times;</button>
                        <div class="loading window  DVmp and DVd" *ngIf="TreatementSelection=='DVd' || TreatementSelection=='DVmp'">

                            <div class="custom-control custom-radio custom-control-inline" (click)="redirection('https://www.ema.europa.eu/en/documents/product-information/darzalex-epar-product-information_es.pdf')">
                                <input type="radio" class="custom-control-input" name="example1">
                                <label class="custom-control-label title" for="customRadio1">
                                    <span>Consult Darzalex® SmPC</span>
                                </label>
                            </div>


                            <div class="custom-control custom-radio custom-control-inline" (click)="redirection('https://www.ema.europa.eu/en/documents/product-information/velcade-epar-product-information_es.pdf')">
                                <input type="radio" class="custom-control-input" id="customRadio2" name="example1">
                                <label class="custom-control-label title" for="customRadio2">
                                    <span>Consult Velcade® SmPC</span>
                                </label>
                            </div>

                        </div>
                        <div class="loading window  DRd" *ngIf="TreatementSelection=='DRd'">
                            <div class="custom-control custom-radio custom-control-inline" (click)="redirection('https://www.ema.europa.eu/en/documents/product-information/darzalex-epar-product-information_es.pdf')">
                                <input type="radio" class="custom-control-input" id="customRadio3" name="example1">
                                <label class="custom-control-label title" for="customRadio3">
                                    <span>Consult Darzalex® SmPC</span>
                                </label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="redirection('https://cima.aemps.es/cima/pdfs/es/ft/107391009/FT_107391009.html.pdf')">
                                <input type="radio" class="custom-control-input" id="customRadio4" name="example1">
                                <label class="custom-control-label title" for="customRadio4">
                                    <span>Consult Lenalidomide SmPC</span>
                                </label>
                            </div>

                        </div>
                        <div class="loading window  D " *ngIf="TreatementSelection=='D'">

                            <div class="custom-control custom-radio custom-control-inline" (click)="redirection('https://www.ema.europa.eu/en/documents/product-information/darzalex-epar-product-information_es.pdf')">
                                <input type="radio" class="custom-control-input" id="customRadio5" name="example1">
                                <label class="custom-control-label title"  for="customRadio5">
                                    <span style="width: 300px;display: block;padding-top: 5px;">Consult Darzalex® SmPC</span>
                                </label>
                            </div>

                        </div>
                        <div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- special population end here-->



        <!-- edit related modal appering start here-->
        <!-- edit modal start here-->
        <div class="modal" id="editEvent">
            <div class="modal-dialog">
                <div class="modal-content" [ngStyle]="{'border-color':selecteddrugcolor }">
                    <!-- Modal body -->
                    <div class="modal-body" [ngStyle]="{'border-color':selecteddrugcolor }">
                        <button type="button" class="close" data-dismiss="modal" (click)="close('editEvent')">&times;</button>
                        <div class="center-align">
                            <!-- <div class="eventbullets dragname">
            <span class="circle-icon" [ngStyle]="{'color':selecteddrugcolor }">
              <i class="fas fa-circle" [ngStyle]="{'background-color':selecteddrugcolor }"></i>
            </span>
            <span class="eventday pointer">{{selecteddrugname}}</span>
          </div> -->
                            <div class="deleteevent pointer" (click)="deleteModal()">
                                <!--openModal() deleteEvent() -->
                                <i class="fas fa-trash-alt" [ngStyle]="{'color':selecteddrugcolor }"></i> 
                                <span i18n="@@deleteEventBtn" >Delete event btn en</span>
                            </div>
                            <div class="editAdminstrator pointer" (click)="editEventAdminstrator()">
                                <i class="fas fa-pen" [ngStyle]="{'color':selecteddrugcolor }"></i> 
                                <span i18n="@@editEventBtn">Edit event btn en</span> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- edit modal end here-->
        <!-- Edit Event Choseby start here-->
        <div class="modal" id="editEventChoseby">
            <div class="modal-dialog">
                <div class="modal-content" [ngStyle]="{'border-color':selecteddrugcolor }">
                    <!-- Modal body -->
                    <div class="modal-body" [ngStyle]="{'border-color':selecteddrugcolor }">
                        <button type="button" class="close" data-dismiss="modal" (click)="close('editEventChoseby')">&times;</button>
                        <form [formGroup]="Editevent" class="formGroup" novalidate>
                            <div class="center-align">
                                <div class="eventbullets dragname pointer">
                                    <i class="fas fa-pen"></i>
                                    <span i18n="@@editAdministrationHeading">Edit administration heading en</span>
                                </div>
                                <div class="editByRoute">
                                    <!-- <i class="fas fa-pen"></i> -->
                                    <!-- <button type="button" class="btn btn-info pointer" data-toggle="collapse"
                data-target="#routeAdminstrator"> -->
                                    <!-- <div>Editar administración</div> -->
                                    <!-- <i class="fas fa-sort-up"></i> -->
                                    <div class="eventbullets dragname">
                                        <span class="circle-icon" [ngStyle]="{'color':changedColor1 }">
                                            <button class="iconButton" mat-button [matMenuTriggerFor]="menu">
                                                <i class="fas fa-circle"></i>
                                            </button>

                                            <mat-menu #menu="matMenu">
                                                <div style="margin-top:5px" fxLayoutGap=10px *ngFor='let color of colorArray'>
                                                    <button class="colorButton" [ngStyle]="{'background-color': color}" (click)='changeColor(color)' mat-mini-fab></button>
                                                </div>
                                            </mat-menu>

                                        </span>
                                        <!-- <input type="text" class="eventday pointer"  formControlName="Editapplyby"  [(ngModel)] ="selecteddrugname"/> -->
                                        <span>{{selecteddrugname}}</span>
                                    </div>
                                    <div class="center-align">
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" class="custom-control-input" id="singleday" formControlName="Ciclocolorcheck" value="To a single day">
                                            <label class="custom-control-label " for="singleday">
                                                <span i18n="@@justThisDay">Just this day en</span>
                                            </label>
                                        </div>

                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" class="custom-control-input" id="entireCycle" formControlName="Ciclocolorcheck" value=" To the entire cycle">
                                            <label class="custom-control-label" for="entireCycle">
                                                <span i18n="@@forTheWholeCycle">For the whole cycle en</span>
                                            </label>
                                        </div>

                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" class="custom-control-input" id="toeverycycle" formControlName="Ciclocolorcheck" value=" To every cycle programmed">
                                            <label class="custom-control-label" for="toeverycycle">
                                                <span i18n="@@forAllCycle">For all cycle en</span>
                                            </label>
                                        </div>
                                        <div class="acceptance-cancel">
                                            <button class=" btn btn-primary" i18n="@@acceptBtn" (click)="handleColorEvent()">{{'Accept btn en' | uppercase}}</button>
                                            <button class="cancel-left btn btn-primary" i18n="@@cancelBtn" (click)="close('editEventChoseby')">{{'Cancel btn en' | uppercase}}</button>
                                        </div>
                                    </div>

                                    <!-- </button> -->

                                    <!--<div id="routeAdminstrator" class="collapse">
                <div ></div>
                <div class="eventbullets dragname">
                  <span class="circle-icon" [ngStyle]="{'color':changedColor }">
                    <button class="iconButton" mat-button [matMenuTriggerFor]="menu"><i class="fas fa-circle"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                     
                      <div style="margin-top:5px" fxLayoutGap=10px *ngFor='let color of colorArray'>
                          <button class="colorButton" [ngStyle]="{'background-color': color}"

                            (click)='changeColor(color)' mat-mini-fab></button>
                      </div>
                    </mat-menu>
                    
                  </span>
                  need to comment <input type="text" class="eventday pointer"  formControlName="Editapplyby"  [(ngModel)] ="selecteddrugname"/> 
                  <span>{{selecteddrugname}}</span>
                </div>
                <div class="center-align">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="singleday" formControlName="Ciclocolorcheck"
                      value="To a single day">
                    <label class="custom-control-label " for="singleday"><span>A un solo día
                      </span></label>
                  </div>

                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="entireCycle" formControlName="Ciclocolorcheck"
                      value=" To the entire cycle">
                    <label class="custom-control-label" for="entireCycle">
                      <span> A todo el ciclo </span>
                    </label>
                  </div>

                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="toeverycycle" formControlName="Ciclocolorcheck"
                      value=" To every cycle programmed">
                    <label class="custom-control-label" for="toeverycycle"><span>A cada ciclo programado
                      </span></label>
                  </div>
                  <div class="acceptance-cancel">
                    <button class=" btn btn-primary" (click)="handleColorEvent()">ACEPTAR</button>
                    <button class="cancel-left btn btn-primary" (click)="close('editEventChoseby')">CANCELAR</button>
                  </div>
                </div>                

              </div>-->
                                </div>
                                <!-- <div class="editByDate">
              <i class="fas fa-pen"></i>
              <button type="button" class="btn btn-info pointer" data-toggle="collapse" data-target="#dateSelection">
                Editar fecha de administración
                <i class="fas fa-sort-up"></i>
              </button>

              <div id="dateSelection" class="collapse">

                <div class="formControlName "> 
                  <mat-form-field>
                    <input matInput id="date" [matDatepicker]="picker" (click)="picker.open();picker.select();"
                      formControlName="Fechaactual" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div> 
                <div *ngIf="daterequired" class="requiredfield">Campo obligatorio</div> 



                <div *ngIf="Editevent.value.Fechaactual" class="center-align">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="radio1" formControlName="Ciclocheck"
                      value="To a single day">
                    <label class="custom-control-label " for="radio1"><span>A un solo día
                      </span></label>
                  </div>

                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="radio3" formControlName="Ciclocheck"
                      value=" To the entire cycle">
                    <label class="custom-control-label" for="radio3"><span>A todo el ciclo
                      </span></label>
                  </div>

                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="radio4" formControlName="Ciclocheck"
                      value=" To every cycle programmed">
                    <label class="custom-control-label" for="radio4"><span>A cada ciclo programado
                      </span></label>
                  </div>
                </div>
                <div class="acceptance-cancel">
                  <button class="accept btn btn-primary" (click)="handleEditEvent ()">ACEPTAR</button>
                  <button class="cancel btn btn-primary" (click)="close('editEventChoseby')">CANCELAR</button>
                </div>
              </div>
            </div> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- Edit Event Choseby modal end here-->

        <!-- edit modal end here-->
        <!-- edit related modal appering end here-->

        <ng-template #warningContentModal let-modal>
            <div class="modal-body">
                {{warningMessage}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="modal.close('Guardar click')">Aceptar</button>
            </div>
        </ng-template>


        <ng-template #deletingContentModal let-modal>
            <div i18n="@@delEventwarning" class="modal-body">Del eventwarning en
            </div>
            <div class="modal-footer">
                <button type="button" i18n="@@deleteBtn" class="btn btn-primary" (click)="deleteEvent();modal.close('Guardar click')">Delete btn en</button>
                <button type="button" i18n="@@cancelBtn" (click)="modal.close('Guardar click')">Cancel btn en</button>
            </div>
        </ng-template>



        <ng-template #alertModal let-modal>
            <div class="modal-body">
                La administración de dosis dividida se ha retrasado al primer día hábil posible, ya que una de las dos administraciones coincide
                con un día festivo
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="modal.close('Guardar click')">OK</button>
            </div>
        </ng-template>


        <ng-template #WeekendModal let-modal>
            <div class="modal-body">
                Algunas adminstraciones coinciden con días festivos o fines de semana. Si lo desea, puede editar estas adminsitraciones,
                u otras de manera manual
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="modal.close('Guardar click')">OK</button>
            </div>
        </ng-template>

        <ng-template #nonbussinessday let-modal>
            <div class="modal-body">
                Se ha detectado que alguna administración estaba programada en día no hábil, por tanto se ha movido al primer día hábil posible
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="_dvmp.setNonBussinessday(false);modal.close('Guardar click')">OK</button>
            </div>
        </ng-template>

        <ng-template #onetimeDragMsg let-modal>
            <div i18n="@@oneTimeDragMsg" class="modal-body">One time drag msg en
            </div>
            <div class="modal-footer">
                <button type="button" i18n="@@acceptBtn" class="btn btn-primary" (click)="modal.close(true)">Accept btn en</button>
                <button type="button" i18n="@@cancelBtn" class="btn btn-primary" (click)="modal.close(false)">Cancel btn en</button>
            </div>
        </ng-template>




        <!--Legal first time disclaimer modal start here -->
        <div class="modal legal" id="legalDisclaimer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 i18n="@@termsModalHeading" class="title legaldisclaimer">Terms modal heading en</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="close('legalDisclaimer')" *ngIf="_termsconditionFlag">&times;</button>
                    </div>
                    <div class="modal-body" id="legalDisclaimerBody">

                        <div class="loading window">
                            <p _ngcontent-c1="" class="title text-center">
                                <!-- <markdown class="mdui" [src]="'../../../assets/files/text.md'"></markdown> -->
                                <p i18n="@@termsSec1">Terms section en
                                </p>
                                <div i18n="@@termsHeading" class="heading" style="margin-bottom:10px;text-decoration: underline;text-align: center !important;font-weight: bold;">
                                    Terms heading en
                                </div>
                                <ul class="tculstyle">
                                    <li i18n="@@termsSec2">Terms section en
                                    </li>
                                    <li i18n="@@termsSec3">Terms section en
                                    </li>
                                    <li i18n="@@termsSec4">Terms section en
                                    </li>
                                    <li i18n="@@termsSec5">Terms section en
                                    </li>
                                    <li i18n="@@termsSec6">Terms section en</li>
                                    <li i18n="@@termsSec7">Terms section en
                                    </li>
                                    <li i18n="@@termsSec8">Terms section en
                                    </li>
                                    <li i18n="@@termsSec9">Terms section en
                                    </li>
                                    <li i18n="@@termsSec10">Terms section en
                                    </li>
                                </ul>
                                <ul class="tculstyle">
                                    <li>
                                        <span i18n="@@termsSec11" style="text-decoration: underline;">
                                            Terms section en
                                        </span>
                                        <p  i18n="@@termsSec12" style="font-style: italic;margin-top: 5px;">Pre infusion heading en</p>
                                        <p i18n="@@termsSec13">Terms section en
                                        </p>
                                        <ul class="beforeP">
                                            <li i18n="@@termsSec14" style="padding-left: 0px;list-style-type: square;">
                                                Terms section en
                                            </li>
                                        </ul>
                                        <p i18n="@@termsSec15">
                                            Terms section en
                                        </p>
                                        <p i18n="@@termsSec16">Terms section en</p>
                                        <p i18n="@@termsSec17">Terms section en
                                        </p>
                                        <p i18n="@@termsSec18">Terms section en
                                        </p>
                                        <ul class="beforeP">
                                            <li i18n="@@termsSec19" style="padding-left: 0px;list-style-type: square;">
                                                Terms section en
                                            </li>
                                            <li i18n="@@termsSec20" style="padding-left: 0px;list-style-type: square;">
                                                Terms section en
                                            </li>
                                        </ul>
                                        <p i18n="@@termsSec21" style="font-style: italic;margin-top: 5px;">Post infusion heading en
                                        </p>
                                        <p i18n="@@termsSec22">Terms section en
                                        </p>
                                        <p i18n="@@termsSec23">
                                            Terms section en
                                        </p>
                                        <p i18n="@@termsSec24">Terms section en
                                        </p>
                                        <p i18n="@@termsSec25">Terms section en
                                        </p>
                                        <p i18n="@@termsSec26">Terms section en
                                        </p>
                                        <p i18n="@@termsSec27">Terms section en
                                        </p>
                                        <p i18n="@@termsSec28" style="font-style: italic">Profilaxisheading en
                                        </p>
                                        <p i18n="@@termsSec29">Terms section en
                                        </p>
                                    </li>
                                    <li i18n="@@termsSec30">Terms section en
                                    </li>
                                </ul>
                                <input type="checkbox" name="termscondition" [(ngModel)]="flagcheck" id="flag" *ngIf="!_termsconditionFlag">
                                <label i18n="@@termsChekText" for="flag" *ngIf="!_termsconditionFlag">Terms chek text en
                                    <br>
                                </label>
                        </div>
                        <p i18n="@@termsCheckErrMsg" class="error-msg" *ngIf='_errorflag'>
                            Terms check err msg en
                        </p>
                        <div class="text-right-btn" *ngIf="!_termsconditionFlag">
                            <button i18n="@@following" (click)="nextClick()" class='btn btn-primary pdf'>Following en</button>
                        </div>
                        <div *ngIf="_termsconditionFlag" class="btn-cerrar">
                            <button i18n="@@closeBtn" type="button" class="btn btn-primary" data-dismiss="modal" (click)="close('legalDisclaimer')">Close btn en</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Legal first time disclaimer modal start here -->